module.exports = __webpack_public_path__ + "img/px.9deef763.png";